import { CUSTOMER_CARE_TEL } from '@/shared/constants/contact';

const CUSTOMER_CARE_PHONE_DISPLAY = '1800-419-0066';

interface PdpDesktopSupportProps {
  onContactClick?: (contactType: 'Call' | 'Chat') => void;
}

export function PdpDesktopSupport({ onContactClick }: PdpDesktopSupportProps) {
  return (
    <p className="hidden text-center text-sm leading-snug text-[#333] md:block">
      Any Questions? Please feel free to reach us at:{' '}
      <a
        href={CUSTOMER_CARE_TEL}
        onClick={() => onContactClick?.('Call')}
        className="font-semibold text-[var(--link-blue)] hover:underline"
      >
        {CUSTOMER_CARE_PHONE_DISPLAY}
      </a>
    </p>
  );
}
